// extracted by mini-css-extract-plugin
module.exports = {"history":"RequestStatusesHistory_history__3zN9e"};